if (process.env.DEV) {
  import('~/legacy/utils/devHotkeys');
}
